import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {create, deleteDetail, editDetails, getList, updateDetails, viewDetails,getQuickSearchList} from '../actions/listing_action';

export default function ListingContainer(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({getList, editDetails, deleteDetail, create, updateDetails, viewDetails,getQuickSearchList}, dispatch);
}

function mapStateToProps(state) {
    return {
        data: state.list.data,
        companyData: state.list.companyData,
        propertyData: state.list.propertyData,
        inspectionData: state.list.inspectionData,
        customerServiceData: state.list.customerServiceData,
        propertyVisitData:state.list.propertyVisitData,
        selectedObject: state.list.selectedObject,
        isFetching: state.list.isFetching,
        userId: state.list.id,
        errorMessage: '',
    };
}



// WEBPACK FOOTER //
// ./src/containers/listing_container.js